module.exports = __webpack_public_path__ + "media/svg-new/logoMini1-a9f464e9.svg";